import lodash from 'lodash';
const container = {
	applyType:"all", // pc phone
	isFullWidthBg:false, // 背景突破
	isFullWidth:false, // 容器宽度突破
	groupName:"container",
	icon: "rowImg",
	level: 1,
	name: "容器", // 标题名称
	compoentName: "container", // 组件名称 
	containerLayout: {
		justify: "center",
		align: "middle",
		pcMax: 1,
		num: 1, // 栅格数量 就是子容器数量
		phoneMax: 1,
		row: {
			gutter: 24,
			type: "flex",
			justify: "start",
			align: "top"
		},
		col: {
			switch: true,
			span: 24,
			offset: 0,
			push: 0,
			pull: 0
		},
		phoneCol: {
			switch: true,
			span: 24,
			offset: 0,
			push: 0,
			pull: 0
		}
	},
	style: {}, // style 配置
	preStyle: {
		sticky: false,
		border: {
			borderRadius:[0,0,0,0],
			borderSize:[0,0,0,0],
			radius: 0,
			type: "solid",
			px: 0,
			color: "#fff"
		},
		padding: [0, 0, 0, 0],
		paddingSetAll: true,
		margin: [0, 0, 0, 0],
		marginSetAll: true,
		bg: {
			
			position:"top left",
			bgtype:"color", // color gradient img
			bgGradient:"",
			bgImgWidth:0,
			bgImgHeigth:0,
			img: "",
			type: "no-repeat"
		},

		boxShadow: {
			h: 0,
			v: 0,
			blur: 0,
			spread: 0,
			color: "",
			type: "outset"
		},

		compontentStyle: {
			// 组件样式实际上是容器样式
			width: 100,
			height: 100,
			percentWidth: 100,
			percentHeight: 100,
			percentWidthSwitch: false,
			percentHeightSwitch: true,
			needHW:false,
			needFont:false
		},
		compontentStylePhone: {
			// 组件样式实际上是容器样式
			width: 100,
			height: 100,
			percentWidth: 100,
			percentHeight: 100,
			percentWidthSwitch: false,
			percentHeightSwitch: true,
			needHW:false,
			needFont:false
		},
		background: {
			sideOrCorner: "left",
			angle: 0,
			color1: "",
			color2: ""
		},
		font: {
			italic: false,
			size: 18,
			weight: "",
			color: "",
			background: {
				angle: 0,
				color1: "",
				color2: ""
			},
		}

	}, // 预编译style 配置
	data: {},
	compontChildren: [],
	children: []
}


// 2层容器
const obj2 = lodash.cloneDeep(container)
obj2.level = 2
// 3层容器
const obj3 = lodash.cloneDeep(container)
obj3.level = 3
delete obj3.children

obj2.children.push(obj3)
// 总共有三层容器
container.children.push(obj2)

export default container

// {
// 		level: 1,
// 		name: "容器", // 标题名称
// 		compoentName: "container", // 组件名称 
// 		containerLayout: {
// 			justify: "start",
// 			align: "top",
// 			num: 1,
// 			pcMax: 1,
// 			phoneMax: 1,
// 			row: {
// 				gutter: 18,
// 				type: "flex",
// 				justify: "start",
// 				align: "top"
// 			},
// 			col: {
// 				switch: true,
// 				span: 24,
// 				offset: 0,
// 				push: 0,
// 				pull: 0
// 			},
// 			phoneCol: {
// 				switch: true,
// 				span:24,
// 				offset: 0,
// 				push: 0,
// 				pull: 0,
// 			}
// 		},
// 		style: {}, // style 配置
// 		preStyle: {
// 			sticky: false,
// 			bottomSticky: false,
// 			border: {
// 				type: "solid",
// 				px: 0,
// 				color: "#fff",
// 				radius: 0

// 			},
// 			margin: [0, 0, 0, 0],
// 			padding: [0, 0, 0, 0],
// 			paddingSetAll: false,
// 			marginSetAll: false,
// 			bg: {
// 				img: "",
// 				type: "no-repeat"
// 			},
// 			boxShadow: {
// 				h: 0,
// 				v: 0,
// 				blur: 0,
// 				spread: 0,
// 				color: "",
// 				type: "outset"
// 			},
// 			background: {
// 				sideOrCorner: "left",
// 				angle: 0,
// 				color1: "",
// 				color2: ""
// 			},
// 			font: {
// 				italic:false,
// 				size: 18,
// 				weight: "none",
// 				color: "",
// 				background: {
// 					angle: 0,
// 					color1: "",
// 					color2: ""
// 				},

// 			}

// 		}, // 预编译style 配置
// 		data: {}, // 数据配置
// 		children: [{
// 			level: 2,
// 			name: "容器", // 标题名称
// 			compoentName: "container", // 组件名称 
// 			containerLayout: {
// 				justify: "start",
// 				align: "top",
// 				pcMax: 1,
// 				num: 1, // 栅格数量 就是子容器数量
// 				phoneMax: 1,
// 				row: {
// 					gutter: 4,
// 					type: "flex",
// 					justify: "start",
// 					align: "top"
// 				},
// 				col: {
// 					switch: true,
// 					span: 24,
// 					offset: 0,
// 					push: 0,
// 					pull: 0
// 				},
// 				phoneCol: {
// 					switch: true,
// 					span: 24,
// 					offset: 0,
// 					push: 0,
// 					pull: 0
// 				}
// 			},
// 			style: {}, // style 配置
// 			preStyle: {
// 				sticky: false,
// 				border: {
// 					radius: 0,
// 					type: "solid",
// 					px: 0,
// 					color: "#fff",

// 				},
// 				padding: [0, 0, 0, 0],
// 				paddingSetAll: false,
// 				margin: [0, 0, 0, 0],
// 				marginSetAll: false,
// 				bg: {
// 					img: "",
// 					type: "no-repeat"
// 				},
// 				boxShadow: {
// 					h: 0,
// 					v: 0,
// 					blur: 0,
// 					spread: 0,
// 					color: "",
// 					type: "outset"
// 				},
// 				background: {
// 					sideOrCorner: "left",
// 					angle: 0,
// 					color1: "",
// 					color2: ""
// 				},
// 				font: {
// 					italic:false,
// 					size: 18,
// 					weight: "none",
// 					color: "",
// 					background: {
// 						angle: 0,
// 						color1: "",
// 						color2: ""
// 					},

// 				}
// 			}, // 预编译style 配置
// 			data: {},
// 			children: [{
// 					level: 3,
// 					name: "容器", // 标题名称
// 					compoentName: "container", // 组件名称 
// 					containerLayout: {
// 						justify: "start",
// 						align: "top",
// 						pcMax: 1,
// 						num: 1, // 栅格数量 就是子容器数量
// 						phoneMax: 1,
// 						row: {
// 							gutter: 24,
// 							type: "flex",
// 							justify: "start",
// 							align: "top"
// 						},
// 						col: {
// 							switch: true,
// 							span: 24,
// 							offset: 0,
// 							push: 0,
// 							pull: 0
// 						},
// 						phoneCol: {
// 							switch: true,
// 							span: 24,
// 							offset: 0,
// 							push: 0,
// 							pull: 0
// 						}
// 					},
// 					style: {}, // style 配置
// 					preStyle: {
// 						sticky: false,
// 						border: {
// 							radius: 0,
// 							type: "solid",
// 							px: 0,
// 							color: "#fff"
// 						},
// 						padding: [0, 0, 0, 0],
// 						paddingSetAll: false,
// 						margin: [0, 0, 0, 0],
// 						marginSetAll: false,
// 						bg: {
// 							img: "",
// 							type: "no-repeat"
// 						},

// 						boxShadow: {
// 							h: 0,
// 							v: 0,
// 							blur: 0,
// 							spread: 0,
// 							color: "",
// 							type: "outset"
// 						},


// 						compontentStylePhone: {
// 							// 组件样式实际上是容器样式
// 							width: 100,
// 							height: 100,
// 							percentWidth: 100,
// 							percentHeight: 100,
// 							percentWidthSwitch: false,
// 							percentHeightSwitch: true,
// 						},


// 						background: {
// 							sideOrCorner: "left",
// 							angle: 0,
// 							color1: "",
// 							color2: ""
// 						},
// 						font: {
// 							italic:false,
// 							size: 18,
// 							weight: "none",
// 							color: "",
// 							background: {
// 								angle: 0,
// 								color1: "",
// 								color2: ""
// 							},

// 						}

// 					}, // 预编译style 配置
// 					data: {},
// 					compontChildren: []
// 				}

// 			]
// 		}], // 嵌套子组件
// 		icon: "el-icon-takeaway-box"
// 	},